import React, { useState, useEffect, useMemo } from 'react';
import {Row, Col, FloatingLabel ,Tooltip, OverlayTrigger, 
  Form, Dropdown, DropdownButton,
  Button , ButtonGroup, Modal,  Accordion, Card } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, addDays, subDays, addMonths, subMonths, startOfMonth, endOfMonth, startOfYear, endOfYear, addYears, subYears, startOfQuarter, endOfQuarter } from 'date-fns';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import AddRecords from "./AddRecords";
import ViewRecords from "./ViewRecords";


import categoryIcon from '../../dist/images/icons/menu/category.png'

import incomeIcon from '../../dist/images/icons/income.png'
import expensesIcon from '../../dist/images/icons/expenses.png'
import downArrowIcon from '../../dist/images/icons/down-arrow.png'
import listIcon from '../../dist/images/icons/list.png'
import addIcon from '../../dist/images/icons/add.png'
import editIcon from '../../dist/images/icons/edit-grn.png'
import deleteIcon from '../../dist/images/icons/delete-grn.png'
import viewIcon from '../../dist/images/icons/view-grn.png'
import LeftIcon from '../../dist/images/icons/left.png'


import category1Icon from '../../dist/images/icons/categories/1.png'
import category2Icon from '../../dist/images/icons/categories/2.png'
import category3Icon from '../../dist/images/icons/categories/3.png'
import category4Icon from '../../dist/images/icons/categories/4.png'
import category5Icon from '../../dist/images/icons/categories/5.png'
import category6Icon from '../../dist/images/icons/categories/6.png'
import category7Icon from '../../dist/images/icons/categories/7.png'
import category8Icon from '../../dist/images/icons/categories/8.png'
import category9Icon from '../../dist/images/icons/categories/9.png'


// import AddCategories from './AddCategories'

const initialbudgetData = [ 
    { no: 1, name: "Coffee", date: "2025-01-15", amount: 150, category: 1 },
    { no: 2, name: "Groceries", date: "2025-01-16", amount: 1200, category: 1 },
    { no: 3, name: "Movie Ticket", date: "2025-01-17", amount: 400, category: 3, sub_budget: [
        { sub_no: 1, name: "Parking", amount: 50 },
        { sub_no: 2, name: "Ticket", amount: 250, sub_budget: [
            { sub_sub_no: 1, name: "Premium Seat", amount: 100 }
        ] },
        { sub_no: 3, name: "Popcorn", amount: 100 }
    ] },
    { no: 4, name: "Gym Membership", date: "2025-01-18", amount: 2000, category: 3 },
    { no: 5, name: "Dinner", date: "2025-01-19", amount: 850, category: 1 },
    { no: 6, name: "Electricity Bill", date: "2025-01-20", amount: 3000, category: 2 },
    { no: 7, name: "Internet Bill", date: "2025-01-21", amount: 1200, category: 2 },
    { no: 8, name: "Books", date: "2025-01-22", amount: 750, category: 3 },
    { no: 9, name: "Taxi", date: "2025-01-23", amount: 500, category: 4 },
    { no: 10, name: "Shopping", date: "2025-01-24", amount: 2500, category: 3 },
    { no: 11, name: "Subscription", date: "2025-01-25", amount: 999, category: 3 },
    { no: 12, name: "Lunch", date: "2025-01-26", amount: 600, category: 1 },
    { no: 13, name: "Water Bill", date: "2025-01-27", amount: 700, category: 2 },
    { no: 14, name: "Concert Ticket", date: "2025-01-28", amount: 1800, category: 3 },
    { no: 15, name: "Gas", date: "2025-01-29", amount: 2200, category: 4 }
];



const Categories = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation()
  const {onFetchData} = location.state || {};

  const [categoryType, setCategoryType] = useState('1');

  const [exportType, setExportType] = useState('xlsx');
  const [categoryData, setCategoryData] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const [showDeleteMsgPopup, setShowDeleteMsgPopup] = useState(false);
  const [dataDeleteId, setDataDeleteId,] = useState(null);

  const [dateRangePicker, setDateRangePicker] = useState('Yearly');
  const [startDatePicker, setStartDatePicker] = useState(startOfMonth(new Date()));
  const [endDatePicker, setEndDatePicker] = useState(endOfMonth(new Date()));
  const [selectedYear, setSelectedYear]= useState(new Date())

  const [dateRangeLimits, setDateRangeLimits]= useState({
    start_date : '',
    end_date: ''
  })

  const [budgetData, setBudgetData] = useState()
  const [groupType, setGroupType] = useState("category");
  const [filterData, setFilterData] = useState({});
  

    const {id} = useParams()
  


  const isCreatePage = location.pathname.includes('records/create/') || location.pathname.includes('records/edit/');
  const isViewPage =  location.pathname.includes('/view/') ;



  const navigate = useNavigate();


  

  const categoryIcons = {
  1: category1Icon,
  2: category2Icon,
  3: category3Icon,
  4: category4Icon,
  5: category5Icon,
  6: category6Icon,
  7: category7Icon,
  8: category8Icon,
  9: category9Icon,
};

  const handleCategotyTypeChange = (type) => {
    setCategoryType(type)
  }


  // const filteredData = categoryData?.filter((item) =>
  //   item?.Category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  // );



  const fetchCategoryOptions = () => {
    axios.get(`${apiUrl}Category`)
          .then(response => {
            setCategoryData(response.data);
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
          });
  }

  const fetchData = () => {
    axios.get(`${apiUrl}Records`)
          .then(response => {
            setBudgetData(response.data);
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
          });
  }

  useEffect(() => {
        fetchData()
        fetchCategoryOptions()
  }, []);

  useEffect(()=>{
    if(onFetchData){
      fetchData()
    }
  }, [onFetchData])

  useEffect(()=>{
      console.log("categoryData", categoryData)
  }, [categoryData])


 
  const handleDeleteChange = (deleteId) => {
    setShowDeleteMsgPopup(true);    
    setDataDeleteId(deleteId)
    console.log(deleteId);
  };

  const handleProposalDeleteCancelled = () => {
    setShowDeleteMsgPopup(false);
  }

  const handleProposalDeleteConfirmed = () => {
    setShowDeleteMsgPopup(false);
    console.log('Delete', dataDeleteId);
    axios.delete(`${process.env.REACT_APP_API_URL}Records/${dataDeleteId}/`)
      .then(response => {
        console.log('Deleted');
        setDataDeleteId(null)
        toast.success("Record Deleted");
        fetchData()
      })
      .catch(error => {
        console.log('Delete Data Error', error);
      });

  }

  const handlePrev = () => {
    if (dateRangePicker === "Day") {
      setStartDatePicker(prev => subDays(prev, 1));
      setEndDatePicker(prev => subDays(prev, 1));
    } else if (dateRangePicker === "Custom") {
      setStartDatePicker(prev => subDays(prev, 7));
      setEndDatePicker(prev => subDays(prev, 7));
    } else if (dateRangePicker === "Monthly") {
      setStartDatePicker(prev => startOfMonth(subMonths(prev, 1)));
      setEndDatePicker(prev => endOfMonth(subMonths(prev, 1)));
    } else if (dateRangePicker === "Yearly") {
      setStartDatePicker(prev => startOfYear(subYears(prev, 1)));
      setEndDatePicker(prev => endOfYear(subYears(prev, 1)));
    } else if (dateRangePicker === "Quarterly") {
      setStartDatePicker(prev => startOfQuarter(subMonths(prev, 3)));
      setEndDatePicker(prev => endOfQuarter(subMonths(prev, 3)));
    }
  };

  const handleNext = () => {
    if (dateRangePicker === "Day") {
      setStartDatePicker(prev => addDays(prev, 1));
      setEndDatePicker(prev => addDays(prev, 1));
    } else if (dateRangePicker === "Custom") {
      setStartDatePicker(prev => addDays(prev, 7));
      setEndDatePicker(prev => addDays(prev, 7));
    } else if (dateRangePicker === "Monthly") {
      setStartDatePicker(prev => startOfMonth(addMonths(prev, 1)));
      setEndDatePicker(prev => endOfMonth(addMonths(prev, 1)));
    } else if (dateRangePicker === "Yearly") {
      setStartDatePicker(prev => startOfYear(addYears(prev, 1)));
      setEndDatePicker(prev => endOfYear(addYears(prev, 1)));
    } else if (dateRangePicker === "Quarterly") {
      setStartDatePicker(prev => startOfQuarter(addMonths(prev, 3)));
      setEndDatePicker(prev => endOfQuarter(addMonths(prev, 3)));
    }
  };

  const handleDateChange = dateOrDates => {
    if (dateRangePicker === "Monthly") {
      setStartDatePicker(startOfMonth(dateOrDates));
      setEndDatePicker(endOfMonth(dateOrDates));
    } else if (dateRangePicker === "Yearly") {
      setStartDatePicker(startOfYear(dateOrDates));
      setEndDatePicker(endOfYear(dateOrDates));
    } else if (dateRangePicker === "Quarterly") {
      setStartDatePicker(startOfQuarter(dateOrDates));
      setEndDatePicker(endOfQuarter(dateOrDates));
    } else if (Array.isArray(dateOrDates)) {
      const [start, end] = dateOrDates;
      setStartDatePicker(start);
      setEndDatePicker(end);
    } else {
      setStartDatePicker(dateOrDates);
      setEndDatePicker(addDays(dateOrDates, 1));
    }
  };

  const handleDateRange = (e, dateRangeId) => {
    setDateRangePicker(dateRangeId);
    const today = new Date(selectedYear);
    if (dateRangeId === "Day") {
      setStartDatePicker(today);
      setEndDatePicker(addDays(today, 1));
    } else if (dateRangeId === "Custom") {
      const startDatePicker = subDays(today, today.getDay());
      const endDatePicker = addDays(startDatePicker, 6);
      setStartDatePicker(startDatePicker);
      setEndDatePicker(endDatePicker);
    } else if (dateRangeId === "Monthly") {
      setStartDatePicker(startOfMonth(today));
      setEndDatePicker(endOfMonth(today));
    } else if (dateRangeId === "Yearly") {
      setStartDatePicker(startOfYear(today));
      setEndDatePicker(endOfYear(today));
    } else if (dateRangeId === "Quarterly") {
      setStartDatePicker(startOfQuarter(today));
      setEndDatePicker(endOfQuarter(today));
    }
  };

  const handleYearChange = (date) => {    
    setSelectedYear(date);    
  };

  useEffect(()=>{
    const end = new Date(selectedYear.getFullYear(), 11, 31);
    setDateRangeLimits({
      start_date : new Date(selectedYear.getFullYear(), 0, 1), 
      end_date: end, 
    });
    setDateRangePicker("Yearly")

    setStartDatePicker(startOfYear(selectedYear));
      setEndDatePicker(endOfYear(selectedYear));
      console.log("selectedYear", selectedYear)

  },[selectedYear])

  const filteredData = useMemo(() => {
        return budgetData?.filter(item => {
            const itemDate = new Date(item.date);
            return (
                (!startDatePicker || itemDate >= startDatePicker) &&
                (!endDatePicker || itemDate <= endDatePicker)
            );
        });
    }, [startDatePicker, endDatePicker, budgetData]);

    // Memoize groupedData to prevent recalculating on every render
    const groupedData = useMemo(() => {
        return filteredData?.reduce((acc, item) => {
            //const groupKey = item[groupType];
            const groupKey = groupType === "date" ? new Date(item.date).toISOString().split("T")[0] : item[groupType];
            
            
            if (!acc[groupKey]) {
                acc[groupKey] = { group: groupKey, group_data: [] };
            }
            acc[groupKey].group_data.push(item);
            return acc;
        }, {});
    }, [filteredData, groupType]);

    useEffect(() => {
        setFilterData(groupedData);
        console.log("filterData", groupedData)
    }, [groupedData]);

    const renderSubBudget = (subBudget, level = 1) => {
        return (
            <ul style={{ paddingLeft: `${level * 20}px` }}>
                {subBudget?.map(sub => (
                    <li key={sub.sub_no || sub.sub_sub_no}>
                        {sub.name} - {sub.amount}
                        {sub.sub_budget && renderSubBudget(sub.sub_budget, level + 1)}
                    </li>
                ))}
            </ul>
        );
    };

    const handleCreateFromChange = (id) => {
      id ? navigate(`./edit/${id}/`) : navigate('/records/create/')
    }
    

    const handleViewDataChange = (id) => {
       navigate(`./view/${id}/`) 
    }


    const exportToExcel = (data) => {
  let excelData = [];

  Object.keys(data).forEach((key) => {
    const group = data[key];
    const groupData = group?.group_data;

    if (groupData?.length > 0) {
      groupData.forEach((item) => {
        excelData.push({
          Group: group.group,
          ID: item.id,
          Name: item.name,
          Amount: item.amount,
          Category: item.category,
          Date: item.date,
        });
      });
    }
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

  saveAs(blob, "exported_data.xlsx");
};



const generatePDF = (data) => {
  const doc = new jsPDF();

  let yOffset = 10;
  Object.keys(data).forEach((date) => {
    const groupData = data[date].group_data;
    doc.text(`Group: ${date}`, 10, yOffset);
    yOffset += 10;

    groupData?.forEach((item, index) => {
      doc.text(`Item ${index + 1}:`, 10, yOffset);
      yOffset += 5;
      doc.text(`Name: ${item.name}`, 10, yOffset);
      yOffset += 5;
      doc.text(`Category: ${item.category}`, 10, yOffset);
      yOffset += 5;
      doc.text(`Account: ${item.account}`, 10, yOffset);
      yOffset += 5;
      doc.text(`Created At: ${item.createdAt}`, 10, yOffset);
      yOffset += 5;
      doc.text(`Date: ${item.date}`, 10, yOffset);
      yOffset += 10;
    });



    // Add a page break if necessary (you can adjust the limit as needed)
    if (yOffset > 250) {
      doc.addPage();
      yOffset = 10;
    }
  });

  doc.save('data.pdf');
};



  return (
    <>
      <Row>
        <Col  >
          <h4 className="main-title pt-2"><img src={categoryIcon} width="25" className="me-2" />Records</h4>
        </Col>

        {/*<Col md="auto">  
          <ButtonGroup aria-label="Basic example" className="categoryType" style={{top: 0}}>
            <Button variant="secondary" onClick={() => generatePDF(filteredData)} >
              <img src={downArrowIcon}  />Export Data</Button>
            
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic" className="active">
                .{exportType}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setExportType('xlsx')} >.xlsx</Dropdown.Item>
                <Dropdown.Item onClick={() => setExportType('pdf')}>.pdf</Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
        </Col>*/}


        <Col  md="auto" >          
          <input type="text" onChange={(e) => setSearchQuery(e.target.value)} className="search-input" placeholder="Search..." value={searchQuery}/>
        </Col>
      </Row >

      <div className="p-4 data-grid my-5">

      <Row className="align-items-center borBottom">
        <Col md="auto">
          <h4 className="main-title m-0 borRight"><img src={listIcon} width="25" className="me-2" /></h4>
        </Col>
        
        <Col md="auto">  
          
            
            Type : 
            <Dropdown className="dropdown-dsn">
              <Dropdown.Toggle variant="success" id="dropdown-basic" className="active">
                {groupType}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setGroupType('amount')} >Amount</Dropdown.Item>
                <Dropdown.Item onClick={() => setGroupType('category')}>Category</Dropdown.Item>
                <Dropdown.Item onClick={() => setGroupType('date')}>Date</Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>

        </Col>

        <Col> 
        <div className="date-filter-date"> 
          <img src={LeftIcon} className="cursor-pointer" width="20" onClick={handlePrev}/>
          <DatePicker
            selected={startDatePicker}
            onChange={handleDateChange}
            startDatePicker={startDatePicker}
            endDatePicker={dateRangePicker === "Custom" || dateRangePicker === "Monthly" || dateRangePicker === "Yearly" || dateRangePicker === "Quarterly" ? endDatePicker : ''}
            selectsRange={dateRangePicker === "Custom"}
            dateFormat={dateRangePicker === "Yearly" ? "yyyy" : dateRangePicker === "Monthly" ? "MMM-yyyy" : dateRangePicker === "Quarterly" ? "yyyy, QQQ" : "dd-MMM-yyyy"}
            showMonthYearPicker={dateRangePicker === "Monthly"}            
            showQuarterYearPicker={dateRangePicker === "Quarterly"}
            disabled={dateRangePicker === "Yearly"}
            minDate={dateRangeLimits.start_date}
            maxDate={dateRangeLimits.end_date}
          />
          <img src={LeftIcon} className="cursor-pointer transform rotate-180" width="20" onClick={handleNext}/>
          </div>
        </Col>

        <Col md="auto">
        <img src={addIcon} className="borRight02 cursor-pointer" width="40" onClick={() => handleCreateFromChange(null)} />
        <Dropdown className="dropdown-dsn borRight02" >
            <Dropdown.Toggle id="dropdown-basic" className="fz-15px py-0 ">
              {dateRangePicker}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={(e) => handleDateRange(e, 'Yearly')}>Yearly</Dropdown.Item>
              <Dropdown.Item onClick={(e) => handleDateRange(e, 'Quarterly')}>Quarterly</Dropdown.Item>
              <Dropdown.Item onClick={(e) => handleDateRange(e, 'Monthly')}>Monthly</Dropdown.Item>
              {/*<Dropdown.Item onClick={(e) => handleDateRange(e, 'Custom')}>Custom</Dropdown.Item>*/}
              {/*<Dropdown.Item onClick={(e) => handleDateRange(e, 'Day')}>Day</Dropdown.Item>*/}             
              
            </Dropdown.Menu>
          </Dropdown>
          <DatePicker
            selected={selectedYear}
            onChange={handleYearChange}            
            showYearPicker
            dateFormat="yyyy"
            dropdownMode="select"   
            className="selected-year "         
          />
        </Col>


        
        
      </Row >
     
    
      {Object?.values(filterData || {})?.map((group, index) => (
        <Accordion key={index} className="ItemAccordion" defaultActiveKey={index.toString()}>
      <Accordion.Item eventKey={index.toString()} key={index}>
        <Accordion.Header className="fw-bold">
          {groupType !== 'category' && groupType.charAt(0).toUpperCase() + groupType.slice(1)} 
          <span className="ms-2">
          {groupType === 'date' && new Date(group.group).toLocaleDateString()}
          {groupType === 'amount' && group.group}
          {groupType === 'category' && 
            categoryData?.find(data => parseInt(data.id) === parseInt(group.group))?.Category
          }
          </span>
        </Accordion.Header>
        <Accordion.Body>
        
          {group?.group_data?.map((item, index) => (
                            <Row key={index} className="data-item">
                            <Col md="5">
                                {item.name} 
                                <span className="editData ms-4">
                                <img src={editIcon} className="cursor-pointer mx-1" width="15" onClick={() => handleCreateFromChange(item.id)} /> 
                                <img src={deleteIcon} className="cursor-pointer mx-1" width="15" onClick={() => handleDeleteChange(item.id)} />
                                <img src={viewIcon} className="cursor-pointer mx-1" width="15" onClick={() => handleViewDataChange(item.id)} />
                                </span>
                                
                            </Col>
                            <Col>
                                <span className={`${item.categoryType === "1" ? 'cl-red' : 'cl-green'}`}> &#8377; {item.amount} </span>
                                
                            </Col>
                            <Col className="text-center">

                                {categoryData?.find(data => parseInt(data.id) === parseInt(item.category))?.Category}
                            </Col>
                            <Col className="text-center " >
                                {new Date(item.date).toLocaleDateString()}
                                
                            </Col>
                           


                            </Row>
                        ))}
          
        </Accordion.Body>

      </Accordion.Item>
      </Accordion>
      ))}
      
      
      

      </div>


       {(isCreatePage || id) && <AddRecords />}
       {isViewPage && <ViewRecords /> }
      <ToastContainer autoClose={1500} />
      <Modal show={showDeleteMsgPopup} onHide={handleProposalDeleteCancelled}>
      <Modal.Body closeButton><h4>Are you sure to delete this Data</h4></Modal.Body>
      <Modal.Footer>
        <button className="btn-lgt-green" onClick={handleProposalDeleteCancelled}>
          Cancel
        </button>
        <button className="btn-green ms-3" onClick={handleProposalDeleteConfirmed}>
          Delete
        </button>
      </Modal.Footer>
      </Modal>
    </>
  );
};

export default Categories;